// Updated Footer.jsx with verified accessibility attributes
import '../shared.css';
import { FaFacebook, FaInstagram, FaEnvelope, FaSquareVimeo } from 'react-icons/fa6';
import SocialIcon from './SocialIcon';

const Footer = () => {
  return (
    <footer className="footer-container">
      <nav className="footer-icon-row" aria-label="Social media links">
        <SocialIcon
          href="https://www.facebook.com/profile.php?id=61564308804072"
          label="Facebook"
          Icon={FaFacebook}
        />
        <SocialIcon
          href="https://www.instagram.com/danggoodleather/"
          label="Instagram"
          Icon={FaInstagram}
        />
        <SocialIcon
          href="https://venmo.com/dangjennydang"
          label="Venmo"
          Icon={FaSquareVimeo}
        />
        <SocialIcon
          href="mailto:boop@danggoodleather.com"
          label="Email"
          Icon={FaEnvelope}
        />
      </nav>

      <div className="footer-center">
        <div className="footer-title">Proudly Queer-Owned</div>
        <div className="footer-subtext">
          © {new Date().getFullYear()} Dang Good Leather — All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
